import Button from '@mui/material/Button';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { ReactElement, ReactNode, useState } from 'react';

import styles from './ArchivedSection.module.scss';

interface IArchivedSectionProps {
  children: ReactNode;
}

const ArchivedSection = ({ children }: IArchivedSectionProps): ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.archived}>
      <Button
        color="primary"
        size="small"
        aria-expanded={open}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={() => setOpen(value => !value)}
        className={styles.archivedToggle}
      >
        Archived
      </Button>
      {open && children}
    </div>
  );
};

export default ArchivedSection;
